import qrcode from "qrcode-generator";

/** Quiet zone the QR specification asks for around the symbol, in modules. */
const QUIET_ZONE = 4;

/**
 * The dark modules of a QR code as one SVG path, drawn client-side so the encoded text
 * (a single-use deep link) never leaves the page as an image request or a data URL.
 */
export function qrSvgPath(text: string): { size: number; path: string } {
  const qr = qrcode(0, "M");
  qr.addData(text);
  qr.make();
  const count = qr.getModuleCount();
  const segments: string[] = [];
  for (let row = 0; row < count; row += 1) {
    for (let col = 0; col < count; col += 1) {
      if (qr.isDark(row, col)) segments.push(`M${col + QUIET_ZONE} ${row + QUIET_ZONE}h1v1h-1z`);
    }
  }
  return { size: count + QUIET_ZONE * 2, path: segments.join("") };
}
